// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as $$String from "../../../../../node_modules/rescript/lib/es6/string.js";
import * as ContentTypes from "../../../../common/types/ContentTypes.bs.js";
import * as ImageContentCmp from "./img-container/ImageContentCmp.bs.js";
import * as TrackLiveTripMarketingVMMapper from "../view-model/TrackLiveTripMarketingVMMapper.bs.js";

function getVehicleStyle(vehicle_current, vehicle_type) {
  if (vehicle_current !== undefined && vehicle_current.vehicle_type === vehicle_type) {
    return "vehicle selected";
  } else {
    return "vehicle";
  }
}

function TrackLiveTripVehicleSwiperSlideCmp(Props) {
  var vehicles_slide = Props.vehicles_slide;
  var selected_vehicle = Props.selected_vehicle;
  var vehicle_selector = Props.vehicle_selector;
  return React.createElement("div", {
              className: "slider-inside-container"
            }, $$Array.mapi((function (_key_inside, vehicle_box) {
                    return React.createElement("div", {
                                key: String(_key_inside),
                                onClick: (function (_e) {
                                    Curry._1(vehicle_selector, vehicle_box);
                                    return TrackLiveTripMarketingVMMapper.publishGAEvents("Vehicle Icon " + vehicle_box.display_name, "");
                                  })
                              }, React.createElement(ImageContentCmp.make, {
                                    title: vehicle_box.display_name.length > 18 ? $$String.sub(vehicle_box.display_name, 0, 18) : vehicle_box.display_name,
                                    class_name: getVehicleStyle(selected_vehicle, vehicle_box.vehicle_type),
                                    background_img: ContentTypes.urltoString(vehicle_box.icon.path),
                                    container_class_name: "vehicle-box"
                                  }));
                  }), vehicles_slide));
}

var make = TrackLiveTripVehicleSwiperSlideCmp;

export {
  getVehicleStyle ,
  make ,
  
}
/* react Not a pure module */
